import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  //首页
  {
    path: "/",
    name: "home",
    meta:{index:0},
    component: require("@/views/Home.vue").default
  },
  //商城
  {
    path: "/shop",
    name: "shop",
    meta:{index:1},
    component: require("@/views/Shop.vue").default
  },
  //支付
  {
    path: "/payment",
    name: "payment",
    meta:{index:1},
    component: require("@/views/Payment.vue").default
  },
  //确认支付
  {
    path: "/pay_confirm",
    name: "payConfirm",
    meta:{index:1},
    component: require("@/views/PayConfirm.vue").default
  },
  //充值
  {
    path: "/pay",
    name: "pay",
    meta:{index:2},
    component: require("@/views/Pay.vue").default
  },
  //登录
  {
    path: "/login",
    name: "login",
    meta:{index:3},
    component: require("@/views/Login.vue").default
  },
]

// eslint-disable-next-line no-new
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
